import { render, staticRenderFns } from "./Migas-list.vue?vue&type=template&id=fa27003a&scoped=true&lang=pug"
import script from "./Migas-list.vue?vue&type=script&lang=js"
export * from "./Migas-list.vue?vue&type=script&lang=js"
import style0 from "./Migas-list.vue?vue&type=style&index=0&id=fa27003a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa27003a",
  null
  
)

export default component.exports